import { defaultAvaAtom, mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import tickCircleIcon from 'assets/images/playroompage-tickCircle.svg'

function SelectAvaMobile({ title }) {
	const { t } = useTranslation()

	const [avaDefault] = useAtom(defaultAvaAtom)
	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	let isSelectAva = false
	const [selectedAva, setSelectedAva] = useState(null)
	function handleSelectAva(avaId) {
		setSelectedAva(avaId)
	}

	return (
		<Container fluid className="selectava-container">
			<Row className="selectava-avastack mobile row-cols-3">
				{avaDefault?.map(item => {
					isSelectAva = selectedAva === item?.id
					return (
						<Col
							key={item?.id}
							className={`selectava-avastack-img 
							${isSelectAva ? 'is-selected' : ''}`}
						>
							<img
								src={item?.image}
								className="ava"
								onClick={() => handleSelectAva(item?.id)}
								alt="Default avatar"
							/>
							{selectedAva && item?.id === selectedAva ? (
								<img
									src={tickCircleIcon}
									className="current"
									alt="Current avatar"
								/>
							) : null}
						</Col>
					)
				})}
			</Row>
			<Row className="profile-confirm-mobile">
				<Button className="confirm-mobile" disabled={!selectedAva}>
					{t('confirm')}
				</Button>
			</Row>
		</Container>
	)
}

export default SelectAvaMobile
